const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <p className="text-xl mt-20">
          I'm someone who din't want to be any part of Software Engineering
          doing a 9 to 5 job. I wanted to explore the world and invent something
          that satisfies my eagerness, walk around alone and enjoy the calmness.
          But things never go as planned.
        </p>

        <br />

        <p className="text-xl">
          I picked up what I dint want, but slowly started enjoying it or may be
          its my nature to excel in whatever I do. I started my career as a
          Software test automation engineer, I like solving problems, finding
          solutions. Build tools that help teams, lead cross functional teams
          and learn new things and tools every day.
        </p>
        <br />
        <p>Respect yourself and others, be humble to everyone and everything</p>
      </div>
    </div>
  );
};

export default About;
